/* tslint:disable */
/* eslint-disable */
/**
 * esign
 * eSign template authoring and request management service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EsignFinalPackageStatus } from './EsignFinalPackageStatus';
import {
    EsignFinalPackageStatusFromJSON,
    EsignFinalPackageStatusFromJSONTyped,
    EsignFinalPackageStatusToJSON,
} from './EsignFinalPackageStatus';
import type { EsignSignerStatus } from './EsignSignerStatus';
import {
    EsignSignerStatusFromJSON,
    EsignSignerStatusFromJSONTyped,
    EsignSignerStatusToJSON,
} from './EsignSignerStatus';

/**
 * 
 * @export
 * @interface PublicSignerSubmitSuccessResponse
 */
export interface PublicSignerSubmitSuccessResponse {
    /**
     * 
     * @type {string}
     * @memberof PublicSignerSubmitSuccessResponse
     */
    request_id: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSignerSubmitSuccessResponse
     */
    request_title: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicSignerSubmitSuccessResponse
     */
    signer_id: string;
    /**
     * 
     * @type {EsignSignerStatus}
     * @memberof PublicSignerSubmitSuccessResponse
     */
    signer_status: EsignSignerStatus;
    /**
     * 
     * @type {Date}
     * @memberof PublicSignerSubmitSuccessResponse
     */
    signer_completed_at: Date;
    /**
     * 
     * @type {string}
     * @memberof PublicSignerSubmitSuccessResponse
     */
    request_status: PublicSignerSubmitSuccessResponseRequestStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof PublicSignerSubmitSuccessResponse
     */
    request_completed_at: Date | null;
    /**
     * 
     * @type {EsignFinalPackageStatus}
     * @memberof PublicSignerSubmitSuccessResponse
     */
    final_package_status: EsignFinalPackageStatus | null;
    /**
     * 
     * @type {string}
     * @memberof PublicSignerSubmitSuccessResponse
     */
    completion_state: PublicSignerSubmitSuccessResponseCompletionStateEnum;
}


/**
 * @export
 */
export const PublicSignerSubmitSuccessResponseRequestStatusEnum = {
    Pending: 'Pending',
    Completed: 'Completed'
} as const;
export type PublicSignerSubmitSuccessResponseRequestStatusEnum = typeof PublicSignerSubmitSuccessResponseRequestStatusEnum[keyof typeof PublicSignerSubmitSuccessResponseRequestStatusEnum];

/**
 * @export
 */
export const PublicSignerSubmitSuccessResponseCompletionStateEnum = {
    SignerCompleted: 'signer_completed',
    RequestCompleted: 'request_completed'
} as const;
export type PublicSignerSubmitSuccessResponseCompletionStateEnum = typeof PublicSignerSubmitSuccessResponseCompletionStateEnum[keyof typeof PublicSignerSubmitSuccessResponseCompletionStateEnum];


/**
 * Check if a given object implements the PublicSignerSubmitSuccessResponse interface.
 */
export function instanceOfPublicSignerSubmitSuccessResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "request_id" in value;
    isInstance = isInstance && "request_title" in value;
    isInstance = isInstance && "signer_id" in value;
    isInstance = isInstance && "signer_status" in value;
    isInstance = isInstance && "signer_completed_at" in value;
    isInstance = isInstance && "request_status" in value;
    isInstance = isInstance && "request_completed_at" in value;
    isInstance = isInstance && "final_package_status" in value;
    isInstance = isInstance && "completion_state" in value;

    return isInstance;
}

export function PublicSignerSubmitSuccessResponseFromJSON(json: any): PublicSignerSubmitSuccessResponse {
    return PublicSignerSubmitSuccessResponseFromJSONTyped(json, false);
}

export function PublicSignerSubmitSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicSignerSubmitSuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'request_id': json['request_id'],
        'request_title': json['request_title'],
        'signer_id': json['signer_id'],
        'signer_status': EsignSignerStatusFromJSON(json['signer_status']),
        'signer_completed_at': (new Date(json['signer_completed_at'])),
        'request_status': json['request_status'],
        'request_completed_at': (json['request_completed_at'] === null ? null : new Date(json['request_completed_at'])),
        'final_package_status': EsignFinalPackageStatusFromJSON(json['final_package_status']),
        'completion_state': json['completion_state'],
    };
}

export function PublicSignerSubmitSuccessResponseToJSON(value?: PublicSignerSubmitSuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'request_id': value.request_id,
        'request_title': value.request_title,
        'signer_id': value.signer_id,
        'signer_status': EsignSignerStatusToJSON(value.signer_status),
        'signer_completed_at': (value.signer_completed_at.toISOString()),
        'request_status': value.request_status,
        'request_completed_at': (value.request_completed_at === null ? null : value.request_completed_at.toISOString()),
        'final_package_status': EsignFinalPackageStatusToJSON(value.final_package_status),
        'completion_state': value.completion_state,
    };
}

